import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppSettingService } from '../services/app-setting.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }
  
  UpdateNotificationViewStatus() {
    // alert('inside AcknowledgeNotification' + NotificationId);
    return this.http
      .post(AppSettingService.updatenotificationviewstatusUri, null).pipe(catchError(this.error));
  }
  
  AcknowledgeNotification(NotificationId: any) {
    // alert('inside AcknowledgeNotification' + NotificationId);
    return this.http
      .post(AppSettingService.acknowledgeNotificationUri ,NotificationId).pipe(catchError(this.error));
  }

  getNotifications(): Observable<any> {
    return this.http
      .get(AppSettingService.getNotificationUri).pipe(catchError(this.error));

  }

  GetSubscribeToTextNotifications(): Observable<any> {
    // alert('inside AcknowledgeNotification' + NotificationId);
    return this.http
      .get(AppSettingService.getSubscribeToTextNotifications).pipe(catchError(this.error));
  }

  setSubscribeToTextNotifications(isSubscribeToTextNotifications:any): Observable<any> {
    // alert('inside AcknowledgeNotification' + NotificationId);
    return this.http
      .post(AppSettingService.setSubscribeToTextNotifications+ "?isSubscribeToTextNotifications=" + isSubscribeToTextNotifications, isSubscribeToTextNotifications).pipe(catchError(this.error));
  }

  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(error);
    return throwError({ error: error.error, status: error.status });
  }

}
